import { concat } from 'lodash';

export const ORDER_ATTRIBUTES = [
  'id',
  'account_id',
  'region_id',
  'address_id',
  'rescheduler_id',
  'rescheduler_type',
  'scheduled_override',
  'external',
  'scheduled',
  'movers',
  'other',
  'materials',
  'moving',
  'storage',
  'scheduled_override_reason',
  'contact_attributes',
  'tags',
  'movers_overwritten_at',
  'labor_exception',
  'mover_override_reason',
  'labor_rate_id',
  'account_packages_attributes',
  'subscribe_attributes',
  'duration',
  'predecessor_id',
  'drop_off_appointment_attributes',
  'per_mover_hour_adjustment_amount',
  'sla_window_size',
] as const;

export const PICKUP_ATTRIBUTES = concat(ORDER_ATTRIBUTES, [
  'metadata_attributes',
  'material_selections_attributes',
  'reset_room_selections_attributes',
  'reset_estimated_items_attributes',
  'reset_estimation_selections_attributes',
  'service_type',
]);

export const RETURN_ATTRIBUTES = concat(ORDER_ATTRIBUTES, [
  'item_ids',
  'cancel_account',
  'reason_id',
  'service_type',
  'account_cancel_intent',
]);

export const MOVE_ATTRIBUTES = [
  ...ORDER_ATTRIBUTES,
  'moving_operation_attributes',
  'moving_selections_attributes',
  'subtype',
] as const;

export const RETAIL_DELIVERY_ATTRIBUTES = ORDER_ATTRIBUTES;

export const MOVE_RESCHEDULE_FEE_DESCRIPTION =
  'A rescheduling fee of $100 will be charged for rescheduling within 48 hours of the appointment. ' +
  'Your initial deposit will be applied towards the new order.';

export type OrderFormType = 'pickup' | 'return' | 'move' | 'retail-delivery';

export const ORDER_FORM_ATTRIBUTES: Record<OrderFormType, readonly string[]> = {
  pickup: PICKUP_ATTRIBUTES,
  return: RETURN_ATTRIBUTES,
  move: MOVE_ATTRIBUTES,
  'retail-delivery': RETAIL_DELIVERY_ATTRIBUTES,
};

export const ORDER_FORM_API_SEGMENTS: Record<OrderFormType, string> = {
  pickup: 'pickups',
  return: 'returns',
  move: 'moves',
  'retail-delivery': 'retail_deliveries',
};
